import { Button } from "components/primitives";
import { Form, Tooltip as BootstrapTooltip } from "react-bootstrap";
import styled from "styled-components";

export const OuterContainer = styled.div`
  position: fixed;
  background-color: white;
  bottom: 20px;
  right: 20px;
  box-shadow: 0 0 8px 0 rgba(0, 9, 43, 0.2);
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 8px;

  > button {
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
  }
`;

export const Pagination = styled.div`
  font-weight: bold;
  margin: 0 2px;
  font-size: 0.8rem;
  min-width: 40px;
  text-align: center;
`;

export const VerticalLine = styled.div`
  background-color: #c4c8cc;
  width: 2px;
  height: 24px;
`;

export const TooltipStyled = styled(BootstrapTooltip)`
  opacity: 1;

  .arrow {
    display: none;
  }

  .tooltip-inner {
    font-size: 1rem;
    font-weight: bold;
    background-color: transparent;
  }
`;

export const LeftArrowBox = styled.button`
  padding: 0;

  &:disabled {
    svg path {
      fill: var(--divider);
    }
  }

  &:hover:enabled {
    filter: brightness(115%);
  }

  svg {
    width: 20px;
    height: 14px;

    path {
      fill: var(--widget-primary);
    }
  }
`;

export const RightArrowBox = styled.button`
  padding: 0;
  margin-right: 10px;

  &:disabled {
    svg path {
      fill: var(--divider);
    }
  }

  &:hover:enabled {
    filter: brightness(115%);
  }

  svg {
    width: 20px;
    height: 14px;

    path {
      fill: var(--widget-primary);
    }
  }
`;

export const AddBtn = styled.button`
  margin: 0 5px;
  padding: 6px;
  border-radius: 5px;
  background-color: transparent;
  transition: background-color 0.3s;
  height: 24px;

  &:hover {
    background-color: var(--widget-primary);

    svg path {
      fill: white;
    }
  }

  &:disabled {
    background-color: transparent;

    svg path {
      fill: var(--gray);
    }
  }

  svg {
    width: 16px;
    height: 16px;

    path {
      transition: fill 0.3s;
      fill: var(--widget-primary);
    }
  }
`;

export const SettingsBtn = styled.button`
  padding: 5px;
  margin-left: 5px;
  border-radius: 5px;

  svg {
    width: 18px;
    height: 18px;

    path {
      fill: var(--widget-primary);
    }
  }

  &:hover {
    background-color: var(--widget-primary);

    svg path {
      fill: white;
    }
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 1.25rem;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-size: 1.15rem;
  margin-bottom: 1rem;
`;

export const LabelInput = styled(Form.Label)<{ $hasLimit: boolean }>`
  font-size: 1.25rem;
  font-weight: bold;

  small {
    display: block;
    font-size: 1rem;
    font-weight: normal;
    color: ${(props) => (props.$hasLimit ? "var(--orange)" : "var(--gray)")};
  }
`;

export const DeleteBtn = styled(Button)`
  background-color: var(--danger);
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 1.25rem 1rem;
  margin-top: 50px;

  svg {
    width: 18px;

    path {
      fill: white;
    }
  }
`;

export const SaveBtn = styled(Button)`
  background-color: var(--widget-primary);
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 1.25rem 1rem;
  margin-top: 50px;
  svg {
    width: 18px;
    path {
      fill: white;
    }
  }
`;

export const ModalMessageBox = styled("div")`
  text-align: center;
  margin-top: 20px;
`;

export const ModalHeaderStyled = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 16pt;

  svg {
    color: var(--primary);
    max-width: 30px;
    margin-right: 20px;
  }
`;
